import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import apiConfig from '../shared/config/api.config';
import { BookingContext } from '../shared/contexts/Booking.context';
import { LoginContext } from '../shared/contexts/Login.context';
import { ThemeContext } from '../shared/contexts/Theme.context';
import { handlePaperlessVersion } from '../shared/utils/version/paperless-version';

export default function Home() {
  const router = useRouter();
  const { actions } = useContext(BookingContext);
  const { actions: loginActions } = useContext(LoginContext);
  const { actions: themeActions } = useContext(ThemeContext);

  useEffect(() => {
    sessionStorage.clear();
    actions.clear();

    const isKiosk =
      new URLSearchParams(window.location.search).get('isKiosk') === 'true' ||
      window.navigator.userAgent.includes('kiosk');
    themeActions.setIsKiosk(isKiosk);

    if (isKiosk) {
      handlePaperlessVersion();
      const hotelId = loginActions.getCurrentHotel();
      if (hotelId) {
        router.push('hotel/[hotelId]/languages', `hotel/${hotelId}/languages`);
      } else {
        router.push('login');
      }
    } else {
      router.push('https://www.civitfun.com/');
    }
  }, []);
  return null;
}
